import {createRouter as createVueRouter, createWebHistory} from 'vue-router';

// **************  Frontend   ************** //

import Index from '@/views/frontend/pages/dashboard/index.vue'
import Chat from '@/views/frontend/pages/chat/chat.vue'
import Settings from '@/views/frontend/pages/settings/settings.vue'
import EmailLogin from '@/views/frontend/pages/email-login.vue'
import ForgotPassword from '@/views/frontend/pages/forgot-password.vue'
import ResetPassword from '@/views/frontend/pages/reset-password.vue'
import ResetPasswordSuccess from '@/views/frontend/pages/reset-password-success.vue'
import Register from '@/views/frontend/pages/register.vue'
import Discover from '@/views/frontend/pages/discover.vue'
import Profile from '@/views/frontend/pages/profile.vue'
import Subscriptions from '@/views/frontend/pages/subscriptions.vue'
import VideoChat from '@/views/frontend/pages/VideoChat.vue'

import authenticated from "@/router/middleware/authenticated";
import csrf from "@/router/middleware/csrf";
import socketConnection from "@/router/middleware/socket-connection";
import isCustomer from "@/router/middleware/is-customer";

const middlewares = {
    authenticated,
    csrf,
    socketConnection,
    isCustomer,
};

const commonMiddlewares = ['csrf'];

const routes = [
    {
        meta: {
            middlewares: ['authenticated'],
        },
        path: '/videochat/:conversationId',
        name: 'videochat',
        component: VideoChat,
    },
    {
        meta: {
            middlewares: ['authenticated', 'socketConnection', 'isCustomer'],
        },
        path: '/',
        name: 'home',
        redirect: '/discover',
    },
    {
        meta: {
            middlewares: ['authenticated', 'socketConnection'],
        },
        path: '/chats',
        name: 'chats',
        component: Index
    },
    {
        meta: {
            middlewares: ['authenticated', 'socketConnection'],
        },
        path: '/chat/:id?',
        name: 'chat-conversation',
        component: Chat
    },
    {
        meta: {
            middlewares: ['authenticated', 'socketConnection'],
        },
        path: '/settings',
        name: 'settings',
        component: Settings,
    },
    {
        meta: {
            middlewares: ['authenticated', 'socketConnection', 'isCustomer'],
        },
        path: '/discover',
        name: 'discover',
        component: Discover
    },
    {
        meta: {
            middlewares: ['authenticated', 'socketConnection', 'isCustomer'],
        },
        path: '/profile',
        name: 'profile',
        component: Profile
    },
    {
        meta: {
            middlewares: ['authenticated', 'socketConnection', 'isCustomer'],
        },
        path: '/subscription',
        name: 'subscription',
        component: Subscriptions,
    },
    {
        meta: {
            middlewares: ['authenticated', 'socketConnection'],
        },
        path: '/user/:username/profile',
        name: 'user-profile',
        component: Profile
    },
    {
        meta: {
            middlewares: ['authenticated'],
        },
        path: '/login',
        name: 'login',
        component: EmailLogin
    },
    {
        meta: {
            middlewares: ['authenticated'],
        },
        path: '/forgot-password',
        name: 'forgot-password',
        component: ForgotPassword
    },
    {
        meta: {
            middlewares: [],
        },
        path: '/reset-password',
        name: 'reset-password',
        component: ResetPassword
    },
    {
        meta: {
            middlewares: [],
        },
        path: '/reset-password-success',
        name: 'reset-password-success',
        component: ResetPasswordSuccess
    },
    {
        meta: {
            middlewares: ['authenticated'],
        },
        path: '/register',
        name: 'register',
        component: Register
    },
];

// Not found
routes.push({
    path: "/:catchAll(.*)",
    redirect: '/chats',
    meta: {
        middlewares: [],
    },
});

routes.forEach(route => {
    commonMiddlewares.forEach(middleware => {
        if (!route.meta.middlewares.includes(middleware)) {
            route.meta.middlewares = [middleware].concat(route.meta.middlewares);
        }
    });
})

export const createRouter = (store) => {
    const router = createVueRouter({
        history: createWebHistory('/'),
        linkActiveClass: 'active',
        routes,
    });

    router.beforeEach(async (to, from, next) => {
        window.scrollTo({top: 0, behavior: 'smooth'});

        for (let name of (to.meta.middlewares || [])) {
            const passed = await middlewares[name](to, from, next, store);

            if (!passed) {
                return;
            }
        }

        await store.dispatch('bootstrap');

        return next();
    });

    return router;
};
